import i18n from 'config/i18n';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const translateErrorCode = (errorCode: number): string => i18n.t(`errorCodes:${errorCode}`, { defaultValue: '' });
